// extracted by mini-css-extract-plugin
export default {"routeBar":"Product_routeBar__ybCsd","sideBar":"Product_sideBar__fO02y","sidBar":"Product_sidBar__3OnAP"};